import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import defaultBot from '../../assets/common/resources/Sikibot.png';
import './index.scss';

const LoadingScreen = ({ message, submessage }) => {
  const { getLoadingConfig } = useTheme();
  const loadingConfig = typeof getLoadingConfig === 'function' ? getLoadingConfig() : {};

  const resolvedIcon = loadingConfig.icon || defaultBot;
  const resolvedAlt = loadingConfig.alt || 'Loading';
  const resolvedMessage = message ?? loadingConfig.message ?? 'Loading...';
  const resolvedSubmessage = submessage ?? loadingConfig.submessage ?? null;

  return (
    <div className="loading-screen">
      <div className="loader">
        <div className="loader-ring"></div>
        <div className="loader-ring"></div>
        <div className="loader-ring"></div>
        <img
          src={resolvedIcon}
          alt={resolvedAlt}
          className="loader-logo"
        />
      </div>
      {resolvedMessage && <p className="loading-message">{resolvedMessage}</p>}
      {resolvedSubmessage && <p className="loading-submessage">{resolvedSubmessage}</p>}
    </div>
  );
};

export default LoadingScreen;
